import * as actionTypes from "./actionTypes";

export const setLeftMarker = (data) => {
	return (dispatch) => {
        dispatch({
            type: actionTypes.CUT_SET_LEFT_MARKER,
            data: data
        });
    }
}

export const setRightMarker = (data) => {
	return (dispatch) => {
        dispatch({
            type: actionTypes.CUT_SET_RIGHT_MARKER,
            data: data
        });
    }
}

export const setTimeLineLength = (length) => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.CUT_SET_TIMELINE_LENGTH,
            length: length
        });
    }
}

export const resetCut = () => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.CUT_RESET
        });
    }
}
